import { render, staticRenderFns } from "./BgImage.vue?vue&type=template&id=085052fe&scoped=true"
import script from "./BgImage.vue?vue&type=script&lang=js"
export * from "./BgImage.vue?vue&type=script&lang=js"
import style0 from "./BgImage.vue?vue&type=style&index=0&id=085052fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085052fe",
  null
  
)

export default component.exports